// Company Details ********************************************************************************
// pathname: /v1/company
// ************************************************************************************************
import { ApiCompanyDetails, ApiCompanyDetailsOk, useSwrApi } from 'src/hooks/useSwrApi';


interface IProps {
  locale?: string;
  serverSideData?: ApiCompanyDetails;
  shouldFetch?: boolean;
}

/**
 * @description SWR: fetch company details
 * @param locale - { string } - the locale to use for the request. Default: 'ro'.
 * @param serverSideData - { ApiCompanyDetails } - the data we got from the server side request (if we do it). Default undefined.
 * @param shouldFetch - { boolean } - if we should fetch the data. Default true.
 */
export const useSwrCompany = ({ locale = 'ro', serverSideData, shouldFetch = true }: IProps) => {
  // Get data from API
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiCompanyDetailsOk>({
    url: '/v1/company',
    locale,
    serverSideData,
    shouldFetch,
    apiOptions: {
      dedupingInterval: 60 * 1000 * 5, // 5 minutes
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
